import SiteNav from './components/SiteNav'
import HeroSection from './components/HeroSection'
import FrontRowSection from './components/FrontRowSection'
import FollowUpSection from './components/FollowUpSection'
import CollectionsSection from './components/CollectionsSection'
import DiscussionSection from './components/DiscussionSection'
import SubscribeSection from './components/SubscribeSection'
import SiteFooter from './components/SiteFooter'

export default function Home() {
  return (
    <div className="min-h-screen w-full bg-background-50 font-body">
      <SiteNav />
      <main>
        <HeroSection />
        <FrontRowSection />
        <FollowUpSection />
        <CollectionsSection />
        <DiscussionSection />
        <SubscribeSection />
      </main>
      <SiteFooter />
    </div>
  )
}